import { createFileRoute } from "@tanstack/react-router";
import { BookOpen } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { ResourcesDocs } from "@/features/resources/modules/docs/docs";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/resources/docs/")({
  loader: () => ({ crumb: m.better_studio_nav_resources_docs() }),
  component: ResourcesDocsPage,
});

function ResourcesDocsPage() {
  return (
    <PageShell
      icon={BookOpen}
      badge={m.better_studio_docs_badge()}
      title={m.better_studio_nav_resources_docs()}
      description={m.better_studio_docs_description()}
      demo
    >
      <ResourcesDocs />
    </PageShell>
  );
}
